import type { SelectOption } from "@/types/SelectOption.ts";

export const optionsUMUIM: SelectOption[] = [
    { id: "", label: "" },
    { id: "Pending", label: "Pending" },
    { id: "No", label: "No" },
    { id: "Yes", label: "Yes" },
];
